<div class="common-options-button-wrapper" (clickOutside)="active=false" [ngClass]="{'disabled':disabled}">
  <div class="btn main-action-wrapper">
    <button class="options-button gen-button-element primary__button" (click)="onClick()">
      <span *ngIf="buttonIconClass" class="btn-icon btn__icon {{buttonIconClass}}"></span>
      <span class="button__text" [innerHtml]="buttonText" translate></span>
    </button>
    <span class="btn-icon options-arrow arrow fa fa-caret-down" (click)="active=!active"></span>
  </div>
  <section class="options-button-options-wrapper" [ngClass]="{'options-shown':active,'area-hidden': !active, 'area-visible': active}">
    <span class="options-button-single-option" *ngFor="let option of options; trackBy:trackByFn"
          (click)="active=false;option.command();">{{option.label | stringTranslate}}</span>
  </section>
</div>
